export default "__VITE_ASSET__CB4zdNnw__"